import PopupManagement from "./-popupManagement";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/platform/popupManagement")({
  staticData: {
    menuLabel: "弹窗管理",
    showInMenu: true,
    menuGroup: "/platform",
    menuOrder: 1,
  },
  component: PopupManagement,
});
